import { render, staticRenderFns } from "./SponsorInfoModal.vue?vue&type=template&id=0a6b3fba&scoped=true&"
import script from "./SponsorInfoModal.vue?vue&type=script&lang=js&"
export * from "./SponsorInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./SponsorInfoModal.vue?vue&type=style&index=0&id=0a6b3fba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b3fba",
  null
  
)

export default component.exports